import { useCallback, useEffect, useId, useState } from 'react';
import { suite, dateExercice } from '../lib/financeSuite';
export const panel='space-y-4 border border-slate-200 bg-white p-4 sm:p-6';
export const button='min-h-11 border border-slate-300 px-3 py-2 text-sm font-semibold disabled:opacity-40';
export const input='mt-1 w-full border border-slate-300 bg-white p-2 text-sm';
const useTestId = label => {
  const id = useId().replace(/[^a-zA-Z0-9-]/g, '');
  return 'finance-suite-' + label.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-' + id;
};
export const Field=({label,children})=><label className="block text-sm">{label}{children}</label>;
export const Text=({label,value,onChange,...props})=>{
  const testId=useTestId(label);
  return <Field label={label}><input data-testid={testId} className={input} value={value ?? ''} onChange={e=>onChange(e.target.value)} {...props}/></Field>;
};
export const Select=({label,value,onChange,options,...props})=>{
  const testId=useTestId(label);
  return <Field label={label}><select data-testid={testId} className={input} value={value} onChange={e=>onChange(e.target.value)} {...props}>{options.map(o=><option key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</option>)}</select></Field>;
};
export const Check=({label,value,onChange,...props})=>{
  const testId=useTestId(label);
  return <label className="flex items-center gap-2 text-sm"><input data-testid={testId} type="checkbox" checked={value} onChange={e=>onChange(e.target.checked)} {...props}/>{label}</label>;
};
export const Action=({children,...props})=>{
  const label=(Array.isArray(children)?children:[children]).filter(x=>typeof x==='string'||typeof x==='number').join(' ');
  const testId=useTestId('action-'+label);
  return <button data-testid={testId} {...props}>{children}</button>;
};
export const Summary=({children,...props})=>{
  const label=(Array.isArray(children)?children:[children]).filter(x=>typeof x==='string'||typeof x==='number').join(' ');
  const testId=useTestId('section-'+label);
  return <summary data-testid={testId} {...props}>{children}</summary>;
};
export function useRapport(path,exercice) {
  const [au,setAu]=useState(()=>dateExercice(exercice)),[data,setData]=useState(null),[error,setError]=useState(''),[busy,setBusy]=useState(false),[tick,setTick]=useState(0);
  useEffect(()=>setAu(dateExercice(exercice)),[exercice]);
  useEffect(()=>{const c=new AbortController();setData(null);setError('');setBusy(true);
    suite(path+'?au='+au,{signal:c.signal}).then(setData).catch(e=>{if(e.name!=='AbortError')setError(e.message);}).finally(()=>{if(!c.signal.aborted)setBusy(false);});
    return ()=>c.abort();
  },[path,au,tick]);
  const reload=useCallback(()=>setTick(x=>x+1),[]);
  return {au,setAu,data,error,setError,busy,setBusy,reload};
}
export const Etat=({busy,error})=>{
  const testId=useTestId('etat');
  return <>{busy&&<p data-testid={testId+'-chargement'} role="status">Chargement…</p>}{error&&<p data-testid={testId+'-erreur'} role="alert" className="border-l-4 border-red-700 bg-red-50 p-3 text-red-800">{error}</p>}</>;
};
export const Controles=({items=[]})=>{
  const testId=useTestId('controles');
  return items.length>0&&<div data-testid={testId} className="bg-amber-50 p-3"><p className="font-semibold">Points à résoudre</p><ul className="list-disc pl-5">{items.map((s,i)=><li key={i}>{s}</li>)}</ul></div>;
};
